import { render, staticRenderFns } from "./Managers.vue?vue&type=template&id=4a4d1b58&scoped=true&"
import script from "./Managers.vue?vue&type=script&lang=js&"
export * from "./Managers.vue?vue&type=script&lang=js&"
import style0 from "./Managers.vue?vue&type=style&index=0&id=4a4d1b58&scoped=true&lang=css&"
import style1 from "./Managers.vue?vue&type=style&index=1&id=4a4d1b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d1b58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCol,VDataTable,VDivider,VForm,VIcon,VRow,VSpacer,VTextField})
